import { windowFF } from "./window";
import { client } from "./initFeatureFlags";
import * as bus from "@sinch/bus";
const isDeepEqual = (object1, object2) => {
    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);
    if (objKeys1.length !== objKeys2.length)
        return false;
    for (const key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];
        const areBothObjects = isObject(value1) && isObject(value2);
        if ((areBothObjects && !isDeepEqual(value1, value2)) ||
            (!areBothObjects && value1 !== value2)) {
            return false;
        }
    }
    return true;
};
const isObject = (object) => object != null && typeof object === "object";
export const assignFeatureFlags = async (user, refreshConfig = true) => {
    const initializedClient = client;
    if (!initializedClient) {
        console.error("ERROR: Trying to run evaluateFeatureFlagsP without having run initFeatureFlags()");
        return Promise.reject("ERROR: Trying to run evaluateFeatureFlagsP without having run initFeatureFlags()");
    }
    try {
        if (refreshConfig) {
            await initializedClient.forceRefreshAsync();
        }
        const featureFlagsList = await initializedClient.getAllValuesAsync(user);
        const mappedFeatureFlag = Object.fromEntries(featureFlagsList.map(({ settingKey, settingValue }) => [settingKey, settingValue]));
        // only update if feature flags are actually different from previous
        if (!windowFF.ff || !isDeepEqual(windowFF.ff, mappedFeatureFlag)) {
            windowFF.ff = mappedFeatureFlag;
            bus.sendLocal(bus.flagsConfigChangedMessage(windowFF.ff));
            console.log("Feature flags updated with:", mappedFeatureFlag);
        }
    }
    catch (error) {
        console.error("ERROR: Failed to evaluate feature flag rules.", error);
    }
};
